// support maps and fonts
export const GOOGLE_API_KEY = 'AIzaSyDq4XyxQ_4U1KyFpLPxk_qXS3NWxJYYyA4'

export const GOOGLE_STATIC_MAP_API = 'https://maps.googleapis.com/maps/api/staticmap'
